export default "__VITE_ASSET__C4u981qo__"